import {
  getSessionStorageMeasureOverviewCompactFilter,
  getSessionStorageMeasureOverviewShowClosedFilter,
  setSessionStorageMeasureOverviewCompactFilter,
  setSessionStorageMeasureOverviewShowClosedFilter,
} from "api/dropsSessionStorage";
import { createContext, useCallback, useState } from "react";

type MeasureOverviewContextValues = {
  compact: boolean;
  toggleCompact: () => void;
  showClosed: boolean;
  toggleShowClosed: () => void;
};

const MEASURE_OVERVIEW_CONTEXT_DEFAULTS: MeasureOverviewContextValues = {
  compact: false,
  toggleCompact: () => {},
  showClosed: false,
  toggleShowClosed: () => {},
};

export const useMeasureOverviewContextValues = () => {
  const [compact, setCompact] = useState(() =>
    getSessionStorageMeasureOverviewCompactFilter(),
  );
  const [showClosed, setShowClosed] = useState(() =>
    getSessionStorageMeasureOverviewShowClosedFilter(),
  );

  const toggleCompact = useCallback(() => {
    setCompact((prev) => {
      setSessionStorageMeasureOverviewCompactFilter(!prev);
      return !prev;
    });
  }, []);

  const toggleShowClosed = useCallback(() => {
    setShowClosed((prev) => {
      setSessionStorageMeasureOverviewShowClosedFilter(!prev);
      return !prev;
    });
  }, []);

  return { compact, toggleCompact, showClosed, toggleShowClosed };
};

export const MeasureOverviewContext = createContext(
  MEASURE_OVERVIEW_CONTEXT_DEFAULTS,
);
